import { useNotifications } from "utils/hooks";

const useTemplatePreview = () => {
  const { pushNotification } = useNotifications();

  /**
   * @param {*} messageProp
   * @param {*} options Configuring the toast notification (varaint and color defined)
   * @param {*} options.simplifiedNotificationColor simplified Color of the <Toast /> component. Uses `color_map`
   * @param {*} options.timeout after what duration to remove the notification from the queue. Denoted in milliseconds
   * @param {*} options.onDelete after what duration to remove the notification from the queue. Denoted in milliseconds
   * @param {*} options.otherProps any other props for the <Toast /> component
   **/
  const pushNotif = (messageProp, options = {}) => {
    pushNotification(messageProp, {
      ...options,
      id: messageProp,
      props: {
        variant: "default",
        color: "coral_red",
        ...(options?.props || {}),
        label: messageProp,
      },
    });
  };

  const validateText = ({
    value,
    enableError,
    setErrorMessage,
    enableErrorText,
    maxLength,
    minLength = 0,
    minLengthMessage = (min) => `Text must be at least ${min} characters`,
    maxLengthMessage = (max) => `Maximum field length of ${max} reached.`,
    allowEmpty = true,
  }) => {
    const length = value?.length || 0;

    // empty value handling
    if (length === 0) {
      if (allowEmpty) {
        setErrorMessage(enableErrorText, null);
        return;
      }
    }

    // min length validation
    if (minLength && length < minLength) {
      enableError(enableErrorText);
      setErrorMessage(enableErrorText, minLengthMessage(minLength));
      return;
    }

    // max length validation
    if (maxLength && length >= maxLength) {
      enableError(enableErrorText);
      setErrorMessage(enableErrorText, maxLengthMessage(maxLength));
      return;
    }

    // valid case
    setErrorMessage(enableErrorText, null);
  };

  return {
    pushNotif,
    validateText,
  };
};

export default useTemplatePreview;
